<div class="modal-header">
	
		<button type="button" class="btn btn-primary btn-lg ml-auto" (click)="cancelOperation()">
			
			Cancel
		</button>
	
</div>
<div class="modal-body">

	<h2 class="text-center">{{ BusyText }}</h2>
	<p class="text-center">
		<i class="fa fa-5x fa-cog fa-spin"></i>
	</p>

</div>
